import {
  SUBSCRIPTION_DISPLAY_NAMES,
  SUBSCRIPTION_TYPES,
  SubscriptionType,
} from "../constants/subscriptionTypes";

/**
 * Normalize subscription type to lowercase to match backend
 */
export const normalizeSubscriptionType = (
  subscriptionType: string | undefined | null
): SubscriptionType => {
  if (!subscriptionType) return SUBSCRIPTION_TYPES.FREE;
  return subscriptionType.toLowerCase() as SubscriptionType;
};

/**
 * Check if user has a free plan
 */
export const isFreeUser = (
  subscriptionType: string | undefined | null
): boolean => {
  return (
    normalizeSubscriptionType(subscriptionType) === SUBSCRIPTION_TYPES.FREE
  );
};

/**
 * Get display name for subscription type
 */
export const getSubscriptionDisplayName = (
  subscriptionType: string | undefined | null
): string => {
  const normalizedType = normalizeSubscriptionType(subscriptionType);
  return SUBSCRIPTION_DISPLAY_NAMES[normalizedType] || "Free";
};

/**
 * Format a label by converting underscores and hyphens to spaces and capitalizing first letter
 * Examples: "content-engine" -> "Content Engine", "smart_list" -> "Smart List"
 */
export const formatLabel = (label: string | undefined | null): string => {
  if (!label) return "";
  // Replace underscores and hyphens with spaces, then capitalize first letter of each word
  return label
    .replace(/[-_]/g, " ")
    .replace(/\b\w/g, (char) => char.toUpperCase());
};
